var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ff5f00;}.cls-4{fill:#eb001b;}.cls-5{fill:#f79e1b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -0.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 20.22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Clipping_Path_2",
    "data-name": " Clipping Path 2",
    width: 32,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circles_only",
    "data-name": "Circles only"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.82,
    y: 3.53,
    width: 6.35,
    height: 12.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.89,10.11A8.12,8.12,0,0,1,16,3.7,8.21,8.21,0,1,0,5.86,16.59a8.16,8.16,0,0,0,10.11,0,8.59,8.59,0,0,1-3.08-6.48",
    transform: "translate(0 -0.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.09,1.91A8.24,8.24,0,0,0,16,3.64a8.1,8.1,0,0,1,1.36,11.47A9.63,9.63,0,0,1,16,16.46a8.17,8.17,0,1,0,10-12.88,8.52,8.52,0,0,0-5-1.67",
    transform: "translate(0 -0.11)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.108e5adc1c72fa524adc2ed8fe6ce493.svg";
export { ForwardRef as ReactComponent };